import {
  useRefractoryCustomizationsQuery as useRefractoryCustomizationsQueryBase,
  type ErrorResponse
} from '@domain/refractory-product-catalog'
import {spawnErrorToast} from '@hm/fundamental'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {logger} from '../utils'

type UseRefractoryCustomizationsQueryParams = Parameters<
  typeof useRefractoryCustomizationsQueryBase
>[0]

export const useRefractoryCustomizationsQuery = (
  params: UseRefractoryCustomizationsQueryParams
) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const query = useRefractoryCustomizationsQueryBase(params)

  useEffect(() => {
    if (query.isError) {
      const errorData = query.error?.response?.data as ErrorResponse | undefined
      const errorDetails =
        errorData?.detail ?? query.error?.message ?? query.error?.response?.status
      logger
        .context('useRefractoryCustomizationsQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching refractory customizations')

      spawnErrorToast(t('error.refractoryCustomizationsQuery'))
    }
  }, [query.isError, query.error, t])

  return query
}
